/*
  Takes api error - determines if invalid phone number
*/
export function isInvalidPhoneInput(error) {
  if (
    error?.graphQLErrors?.[0]?.extensions?.code === 'INVALID_RESERVATION_INPUT' &&
    error?.graphQLErrors?.[0]?.extensions?.status === 400 &&
    error?.graphQLErrors?.[0]?.extensions?.details.includes("Key: 'CreateReservationInput.customer.phone'")
  ) {
    return true;
  }

  return false;
}

/*
  Takes api error - determines if invalid email
*/
export function isInvalidEmailInput(error) {
  if (
    error?.graphQLErrors?.[0]?.extensions?.code === 'INVALID_RESERVATION_INPUT' &&
    error?.graphQLErrors?.[0]?.extensions?.status === 400 &&
    error?.graphQLErrors?.[0]?.extensions?.details.includes("Key: 'CreateReservationInput.customer.email'")
  ) {
    return true;
  }

  return false;
}
